import React from 'react';

const AppContext = React.createContext();
const AppState = {
  CAT_12: 'ABHI_CAT12_PROD',
  GENERIC_PROD: 'GENERIC_PROD',
}
class AppContextProvider extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      applicationState: null,
      entityDetails: null,
    };
  }

  render() {
    return (
      <AppContext.Provider
        value={{
          applicationState: this.state.applicationState,
          entityDetails: this.state.entityDetails,
          setApplicationState: (stateName) => {
            if (![AppState.CAT_12, AppState.GENERIC_PROD].includes(stateName)) return;
            this.setState({
              applicationState: stateName
            })
          },
          setEntityDetails: (entityDetails) => {
            this.setState({
              entityDetails: entityDetails
            })
          }
        }}
      >
        {this.props.children}
      </AppContext.Provider>
    );
  }
}

export default AppContext;
export {
  AppContextProvider,
  AppState
}
